<template lang="pug">
    .row.wizard-wrapper
        .col-12.col-sm-12.col-md-12
            .wizard-progress
                .step(:class="{'in-progress': (step == 1), 'complete': (step > 1)}")
                    .outer-label
                        span.span-inner Comienzo
                    .node
                .step(:class="{'in-progress': (step == 2), 'complete': (step > 2)}")
                    .outer-label
                        span.span-inner Detalles personales
                    .node
                .step(:class="{'in-progress': (step == 3), 'complete': (step > 3)}")
                    .outer-label
                        span.span-inner Cualificaciones
                    .node
                .step(:class="{'in-progress': (step == 4), 'complete': (step > 5)}")
                    .outer-label
                        span.span-inner Pago
                    .node
                .step(:class="{'in-progress': (step == 5), 'complete': (step > 6)}")
                    .outer-label
                        span.span-inner Confirmación
                    .node
</template>

<script>

export default {
    name: 'Wizard',
    props: {
        step: 1,
    },
}
</script>

<style scoped lang="scss">
@import "./../../variables";

// WIZARD
.wizard-wrapper {
    padding-bottom: $gutter*2;
}

$wizard-active-color: #3c4b54;
$wizard-disable-color: #98a0a6;
$wizard-complete-color: #8cb610;

.wizard-progress{
    display: table;
    width: 100%;
    table-layout: fixed;
    position:relative;
    margin: $gutter 0 $gutter*2 0;

    .step {
        display: table-cell;
        text-align: center;
        vertical-align: top;
        overflow: visible;
        position:relative;
        font-size: 14px;
        color: #fff;
        font-weight: bold;

        .outer-label {
            position: relative;
            width: 100%;

            .span-inner {
                @include clearfix;
                display: inline-block;
                position: absolute;
                display: inline-block;
                padding-right: 18px;
                text-align: center;
                width: 100%;
                color: $wizard-disable-color;
                top: 60px;
                font-weight: 300;
                left: 0;
                right: 0;
            }
        }

        &:not(:last-child):before{
            content: '';
            display:block;
            position: absolute;
            left: 49%;
            top: 36px;
            background-color: $wizard-disable-color;
            height: 2px;
            width: 100%;
        }

        .node{
            display: inline-block;
            border: 6px solid $wizard-disable-color;
            background-color: $wizard-disable-color;
            border-radius: 24px;
            height: 24px;
            width: 24px;
            position: absolute;
            top: 25px;
            left: 50%;
            margin-left: -24px;
        }

        &.complete{
            &:before{
                background-color: $wizard-complete-color;
            }
            .node{
                border-color: $wizard-complete-color;
                background-color: $wizard-complete-color;

                &:before{
                    font-family: FontAwesome;
                    content: "\f00c";
                }
            }
        }

        &.in-progress{
            &:before{
                background: $wizard-active-color;
            }
            .node{
                border-color: $wizard-active-color;
                background-color: #fff;
            }
        }
    }

    .step.complete {
        .outer-label {
            .span-inner {
                color: $wizard-complete-color;
            }
        }
    }

    .step.in-progress {
        .outer-label {
            .span-inner {
                color: $wizard-active-color;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/components/register/Wizard.vue